import React from 'react';
import ReviewForm from './Review';
import { Flex, Space, Typography } from 'antd';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa6';

const { Title } = Typography;

const CompletedReviewComp = ({ reviewData }) => {
  const navigate = useNavigate();
  return (
    <div className="container-fluid px-2 px-md-3">
      <Flex align="center" gap={8} className="mb-3">
        <span
          className={`border px-2 pb-1 cursor-pointer`}
          onClick={() => navigate(-1)}
        >
          <FaArrowLeft size={16} />
        </span>
        <Title level={4} className="text-dark fw-semibold mt-0 mb-1">
          HR Review
        </Title>
      </Flex>
      <ReviewForm
        monthLabel={'Completed Review'}
        value={{
          employee_review: {
            feedback: reviewData?.employee_review?.feedback || [],
            rating: reviewData?.employee_review?.rating || [],
          },
          manager_review: {
            feedback: reviewData?.manager_review?.feedback || [],
            rating: reviewData?.manager_review?.rating || [],
          },
          hr_review: {
            comments: reviewData?.hr_review?.comments || null,
          },
        }}
      >
        <Space direction="vertical" size="middle" className="w-100">
          <ReviewForm.EmployeeInfoHeader
            employeeName={
              reviewData?.NewUserMaster
                ? `${reviewData?.NewUserMaster?.first_name} ${reviewData?.NewUserMaster?.last_name}`
                : '--'
            }
            department={reviewData?.department_name || '--'}
            manager={reviewData?.department_head_name || '--'}
            reviewMonth={`${reviewData?.month} ${reviewData?.year}`}
          />
          <ReviewForm.EmployeeReviewSummary
            headerTitle="Employee Review Summary"
            summary={{
              totalHours: reviewData?.total_hours || 0,
              projects: reviewData?.projects_worked || 0,
              leaves: reviewData?.total_leaves || 0,
              attendancePct: reviewData?.attendance_percentage || 0,
            }}
            feedback={reviewData?.employee_review?.feedback || []}
            rates={reviewData?.employee_review?.rating || []}
          />
          <ReviewForm.ManagerReviewSummary
            headerTitle="Manager Review Summary"
            managerFeedback={reviewData?.manager_review?.feedback || []}
            rates={reviewData?.manager_review?.rating || []}
            overallRating={reviewData?.manager_review?.over_all_rating || 0}
          />

          <ReviewForm.CompletedReviewSummary
            headerTitle="HR Comments"
            hrComments={reviewData?.hr_review?.comments || null}
          />
        </Space>
      </ReviewForm>
    </div>
  );
};

export default CompletedReviewComp;
